import { dayjs } from "Config/dayjs";
import { useState } from "react";
import { userInfoStore } from "Stores";
import { Button, DatePicker as AntdDatePicker } from "antd";
import { DatePickerProps } from "antd/lib/date-picker";
import deDE from "antd/es/date-picker/locale/de_DE";
import enGB from "antd/es/date-picker/locale/en_GB";
import { observer } from "mobx-react";

export const DatePicker = observer(
  (props: DatePickerProps & { placeHolderButton?: string; placeHolderButtonDisabled?: boolean }) => {
    const { value, onChange, placeHolderButton, placeHolderButtonDisabled, size, ...other } = props;
    const time = value ? dayjs(value as dayjs.Dayjs) : null;
    const [showPicker, setShowPicker] = useState<boolean>(false);
    const localeFile = userInfoStore.language === "de" ? deDE : enGB;
    const triggerChange = (_, dateStr) => {
      onChange && onChange(_, dateStr);
    };
    if (placeHolderButton && !value && !showPicker) {
      return (
        <Button disabled={placeHolderButtonDisabled} size={size} onClick={() => setShowPicker(true)}>
          {placeHolderButton}
        </Button>
      );
    }

    return <AntdDatePicker defaultValue={time} onChange={triggerChange} size={size} {...other} locale={localeFile} />;
  }
);

export default DatePicker;
